<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2021-11-08 22:05:48
 * @LastEditors: 刘帅博 liushuaibo@yangxuan.net
 * @LastEditTime: 2023-08-05 11:54:40
-->
<template>
	<!-- 修改备注 -->
	<el-dialog
		width="400px"
		title="解绑原因"
		:visible.sync="visible"
		:append-to-body="true"
		:before-close="beforeClose"
		:close-on-click-modal="false"
	>
		<div>
      {{ remarks }}
    </div>
		<div slot="footer" class="dialog-footer">
			<el-button type="primary" @click="beforeClose">知道了</el-button>
		</div>
	</el-dialog>
</template>
<script>
export default {
	name: 'reasonDialog',
	data() {
		return {
			visible: false,
      remarks: ''
		};
	},
	methods: {
		show(remarks) {
      this.remarks = remarks
			this.visible = true;
		},
		beforeClose() {
      this.remarks = ''
			this.visible = false;
		},
	},
};
</script>
<style scoped></style>
